<template>
  <el-tabs class="yh-tab-header"
           v-model="activeName"
           type="card"
           @tab-click="handleTabsClick"
           @tab-remove="handleTabsRemove">
    <el-tab-pane v-for="item in tabs"
                 :key="item.path"
                 :label="item.name"
                 :name="item.path"
                 :closable="item.path !=='/Home'">
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { removeTab } from '@/mixins';

export default {
  name: 'YhTabs',
  mixins: [removeTab],
  data() {
    return {
    };
  },
  computed: {
    tabs() {
      return this.$store.state.pageTab;
    },
    activeName: {
      get() {
        return this.$store.state.activeName;
      },
      set(v) {
        this.$store.commit('setActiveTab', v);
      },
    },
  },
  methods: {
    handleTabsClick(tab) {
      this.$router.push({
        path: tab.name,
      });
    },
  },
};
</script>

<style lang="scss">
.yh-tab-header.el-tabs--card > .el-tabs__header .el-tabs__item {
  // 覆盖 element 样式
  border-bottom: 1px solid #e4e7ed;
}
.yh-tab-header.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  // 覆盖 element 样式
  border-bottom: 0;
}
.yh-tab-header .el-tabs__header {
  margin: 0;
}
.yh-tab-header .el-tabs__item {
  background-color: #fff;
  &:first-of-type {
    border-top-left-radius: 3px;
  }
  &:last-of-type {
    border-top-right-radius: 3px;
  }
}
.yh-tab-header.el-tabs--card > .el-tabs__header {
  border-bottom: 0;
}
</style>
